module.exports = __webpack_public_path__ + "static/media/icon_instagram.e77dc9eb.svg";